<template>
  <b-card no-body>

    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row>
          <b-col md="4">
            <lg-finder-page-unidade-administrativa v-model="form.departamentoSolicitante"
              :podeApagarDepartamento="temPrivilegioGerenciarParecerSolicitacaoMovimentacao()"
              :podeMudarDepartamento="temPrivilegioGerenciarParecerSolicitacaoMovimentacao()"
              :prefix="prefix + title + ' > '" id="finderDepartamentoSolicitante"
              @onselect="departamentoSolicitanteSelect" label="UA-Solicitante">
            </lg-finder-page-unidade-administrativa>
          </b-col>

          <b-col md="4">
            <lg-finder-page-pessoa v-model="form.usuarioSolicitante" id="finderUsuarioSolicitante"
              @onselect="usuarioSolicitanteSelect" label="Responsável:" :prefix="prefix + title + ' > '">
            </lg-finder-page-pessoa>

          </b-col>
          <lg-form-const-select label="Status:" @change="load()" v-model="form.status" :options="status" sm="4" />

          <b-col cols="12" class="text-right">

            <b-button v-if="temPrivilegioGerenciarParecerSolicitacaoMovimentacao()" id="apagar-tarefa"
              class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary" @click="clearForm">
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              <b-tooltip target="apagar-tarefa" title="Limpar"></b-tooltip>
            </b-button>

            <b-button id="localizarTarefaMovimentacao" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
              variant="primary" @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizarTarefaMovimentacao" title="Localizar"></b-tooltip>
            </b-button>
          </b-col>
        </b-form-row>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" show-empty>
          <template #empty>
            <p>
              Nenhum registro encontrado
            </p>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(codTipoTarefaSolMovIbp)="{ item }">
            <span @click="abrirDetalhe(item)" style="color: blue; cursor: pointer">{{
              item.codTipoTarefaSolMovIbp.descricao
            }}</span>
          </template>

          <template v-slot:cell(action)="{ item }">
            <div class="text-center">
              <b-button id="iniciar" v-if="isBtnIniciarVisible(item)" pill size="sm" variant="primary"
                title="Iniciar a tarefa atual..." @click="iniciarTarefa(item)">
                <b-icon icon="file-earmark-play" />
              </b-button>


              <b-button v-if="
                isBtnContinuarVisible(item)
              " pill size="sm" variant="primary" title="Continuar a tarefa atual..." @click="abrirModalTarefa(item)">
                <b-icon icon="file-earmark-bar-graph" />
              </b-button>
            </div>
          </template>

          <template v-slot:cell(agendamento)="{ item }">
            <b-button v-if="isAprovacaoRetirada(item)" :id="'agendar-tarefa' + item.id" pill size="sm" variant="primary"
              @click="abrirModalAgendamento(item)">
              <b-icon icon="calendar" />
              <b-tooltip :target="'agendar-tarefa' + item.id" title="Agendamento de Retirada"></b-tooltip>
            </b-button>


          </template>


        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <ModalAgendamento :isVisualizacao="isVisualizarAgendamento" @close="fecharAgendamento" v-if="mostrarAgendamento"
      :tarefa="tarefa" :prefix="prefix + title + ' > '"></ModalAgendamento>

    <TarefaForm @close="fecharModalTarefa" :id="id" :isVisualizacao="isVisualizacao" v-if="mostrarTarefaForm"
      :prefix="prefix + title + ' > '"></TarefaForm>


    <ModalLogin :tarefa="tarefa" @usuarioAutenticado="abrirModalTarefaShow"  :isPedido="false" @close="cancelarLogin" :disabledLogin="true" :login="usuario.login" v-if="showLogin">
    </ModalLogin>
  </b-card>
</template>

<script>
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import TipoStatusEnum from "@/core/utils/TipoStatusEnum";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import StatusEnum from "@/core/utils/StatusEnum";
import TarefaForm from "./TarefaForm.vue";
import ModalAgendamento from '@/core/components/Modals/ModalAgendamento.vue';
import TipoTarefaSolMovIBPEnum from "@/core/utils/TipoTarefaSolMovIBPEnum";
import ModalLogin from "@/modules/almoxarifados/pedidos/ModalLogin.vue";

export default {
  components: {
    ModalAgendamento,
    LgFinderPagePessoa,
    LgFormConstSelect,
    LgFinderPageUnidadeAdministrativa,
    TarefaForm,
    ModalLogin
  },
  props: {
    title: { type: String, default: "Solicitação de Movimentação" },
    prefix: { tpye: String, default: "" },
    executarMetodo: Boolean,

  },


  data() {
    return {
      showLogin: false,
      usuario: {},
      exigeLogin: true,
      isVisualizarAgendamento: false,
      tarefa: {},
      id: null,
      isVisualizacao: false,
      mostrarTarefaForm: false,
      mostrarAgendamento: false,
      status: [],
      params: {},
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      form: {
        status: -1,
        departamentoSolicitante: {},
        usuarioSolicitante: {},

      },
    };
  },

  mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

  async beforeMount() {
    this.$service = new ResourceService(`/api/tarefa-solmovibp`);
    this.$statusService = new ResourceService(`/api/status/tipo/${TipoStatusEnum.TAREFA_SOL_MOV_IBP.cod}`);
    this.$serviceHistorico = new ResourceService(`/api/historicocarga`);

    if (verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO)) {
      this.exigeLogin = false;
    }

    this.brand = JSON.parse(localStorage.getItem("context"));
    this.form.departamentoSolicitante = this.brand.departamento;
    this.usuario = this.brand.usuario;

    this.carregarStatus();
    this.load();


  },

  watch: {
    page() {
      this.load();
    },

    executarMetodo(newVal) {

      if (newVal) {
        this.load();
      }
    },

  },

  computed: {
    tableFields() {
      return [
        { key: "id", label: "Nº" },

        { key: "codStatus.descricao", label: "Status" },

        {
          key: "codDepartamento.descricao",
          label: "Unidade Administrativa",
        },

        { key: "codPessoa.nome", label: "Responsavel" },
        { key: "descTipoSolicitacaoMovimentacao", label: "Tipo" },


        {
          key: "codTipoTarefaSolMovIbp",
          label: "Tarefa",
        },

        {
          key: "dhCriacao",
          label: "Criação",
          formatter: (value) => moment(value).format("DD/MM/YYYY"),
        },

        { key: "action", label: " " },
        { key: "agendamento", label: " " }

      ];
    },
  },

  methods: {

    mostrarLogin(tarefa) {
      this.tarefa = tarefa;
      this.showLogin = true;
    },
    cancelarLogin() {
      this.tarefa = {};
      this.showLogin = false;
    },

    isAprovacaoRetirada(item) {
      return item.codTipoTarefaSolMovIbp.id == TipoTarefaSolMovIBPEnum.EXECUCAO_RETIRADA.value;
    },

    fecharAgendamento() {
      this.isVisualizarAgendamento = false;
      this.tarefa = {};
      this.mostrarAgendamento = false;
      this.isVisualizacao = false;
      this.load();
    },
    abrirModalAgendamento(item) {
      this.isVisualizarAgendamento = item.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_FINALIZADA.value || item.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_EXPIRADO.value
      this.tarefa = item;
      this.mostrarAgendamento = true;

    },
    verificaPrivilegioParaLogin() {
      return verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO);
    },
    abrirModalTarefaShow(item) {
      this.cancelarLogin();
      this.id = item.id;
      this.mostrarTarefaForm = true;

    },
    abrirModalTarefa(item) {

      if (this.exigeLogin) {
        this.mostrarLogin(item);
      }
      else {
        this.abrirModalTarefaShow(item);
      }
    },
    fecharModalTarefa() {
      this.id = null;
      this.isVisualizacao = false;
      this.mostrarTarefaForm = false;
      this.load();
    },
    async iniciarTarefa(item) {
      let response = await this.$confirm(
        `Deseja iniciar esta tarefa (${item.codTipoTarefaSolMovIbp.descricao}) ?`
      )
      if (response) {

        try {
          this.busy = true;
          await this.$service.put("iniciar-tarefa/" + item.id);
          this.busy = false;
          this.$notify({
            type: "success",
            message: "Tarefa iniciada com sucesso!",
          })

          this.abrirModalTarefa(item);
        } catch (error) {
          this.busy = false;
          this.$notify({
            type: "danger",
            message: error,
          });
        }


      }
    },

    abrirDetalhe(item) {
      this.isVisualizacao = true
      this.abrirModalTarefa(item);

    },
    isBtnContinuarVisible(data) {
      return data != null && data.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_EM_ANDAMENTO.value && data.codDepartamento.id == this.brand.departamento.id && verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO);

    },

    isBtnIniciarVisible(data) {
      return data != null && data.codStatus.id == StatusEnum.TAREFA_SOL_MOV_IBP_AGUARDANDO.value && data.codDepartamento.id == this.brand.departamento.id && verificaPrivilegio(PrivilegiosEnum.SOLICITACAO_MOV_APROVACAO);

    },
    temPrivilegioGerenciarParecerSolicitacaoMovimentacao() {
      return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PARECER_SOLICITACAO_MOVIMENTACAO);

    },
    clearForm() {
      this.form.departamentoSolicitante = {};
      this.form.status = -1;
      this.form.usuarioSolicitante = {};

    },
    departamentoSolicitanteSelect(item) {
      this.form.departamentoSolicitante = item;
      this.load();
    },
    usuarioSolicitanteSelect(item) {
      this.form.usuarioSolicitante = item;
      this.load();
    },
    async load() {

      this.busy = true;
      this.params = {};

      this.params.departamento = this.form.departamentoSolicitante.id;

      if (this.form.usuarioSolicitante && this.form.usuarioSolicitante.id)
        this.params.usuarioSolicitante = this.form.usuarioSolicitante.id;

      if (this.form.status)
        this.params.status = this.form.status;

      this.$emit("pesquisouTarefas");

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: this.params,
      });

    },



    async carregarStatus() {
      await this.$statusService.findAll({
        page: 0,
        size: 10,
        filter: false,
        isOrOperation: undefined,
        params: {},
      }).then(response => {
        this.status.push({ value: -1, text: 'Aguardando/Em andamento' });

        response.data.content.forEach(item => {
          this.status.push({ value: item.id, text: item.descricao });
        });
      });



    },

  },
};
</script>
